import { flowHomeZH } from './flow/home'
import { flowAcademicReportZH } from './flow/academicReport'
import { flowActiveZH } from './flow/active'
import { flowAdmissionTicketZH } from './flow/admissionTicket'
import { flowCertificateZH } from './flow/certificate'
import { flowComplainZH } from './flow/complain'
import { flowConsultZH } from './flow/consult'
import { flowCouponZH } from './flow/coupon'
import { flowDiscoverZH } from './flow/discover'
import { flowFollowUsZH } from './flow/followUs'
import { flowGradeReportZH } from './flow/gradeReport'
import { flowGroupZH } from './flow/group'
import { flowLoginZH } from './flow/login'
import { flowMessageZH } from './flow/message'
import { flowOrderZH } from './flow/order'
import { flowPayTheFeesZH } from './flow/payTheFees'
import { flowPersonalDataZH } from './flow/personalData'
import { flowReviewZH } from './flow/review'
import { flowSignUpZH } from './flow/signUp'
import { flowTaskZH } from './flow/task'
import { flowTeamUpZH } from './flow/teamUp'
import { flowImageZH } from './flow/image'

const messages = {
  back: '返回',
  msg: '消息',
  msgcenter: '消息中心',
  home: {
    tabs: {
      txt1: '项目活动',
      txt2: '课程中心',
      txt3: '精彩图集',
      txt4: '关于我们'
    },
    logs: {
      txt1: '即将上线'
    },
    footTabs: {
      txt1: '首页',
      txt2: '广场',
      txt3: '我的活动',
      txt4: '个人中心'
    },
    capsule: {
      txt1: '已报名的活动',
      txt2: '任务进度',
      txt3: '开始学习'
    },
    hotActivities: {
      txt1: '今日热门',
      txt2: '大家都在追的能力提升计划'
    },
    activeItem: {
      txt1: '报名进行中'
    },
    recommendList: {
      txt1: '为你推荐活动',
      txt2: '数万初高中学生的选择',
      txt3: '显示全部活动'
    },
    atlasList: {
      txt1: '为你推荐图集',
      txt2: '活动期间的精彩照片',
      txt3: '显示全部图集'
    },
    palaza: {
      txt1: 'BLOOM活动广场',
      txt2: '一起学，一起浪',
      txt3: '进入广场'
    },
    howToJoin: {
      txt1: '如何参与我们的活动',
      txt2: '简单四步，开启精彩'
    },
    howToLearn: {
      txt1: '体验PBL项目式学习',
      txt2: '团队作战，精益求精'
    },
    tabslist: {

    }
  },
  userCenter: {
    panel: {
      txt1: '我的活动',
      txt2: '我的优惠券',
      txt3: '账号管理',
      txt4: '咨询与反馈',
      txt5: '关于我们',
      txt6: '退出登录',
      txt7: '确定要退出登录吗？',
      txt8: '我的订单',
      txt9: '中英文切换',
      txt10: '消息中心'
    },
    acountManage: {
      txt1: '账号管理',
      txt2: '登录账号',
      txt3: '手机',
      txt4: '邮箱',
      txt5: '修改密码',
      oldPassword: '请输入旧密码',
      newPassword: '请输入新密码',
      rePassword: '请再次输入新密码',
      graphicverificationCode: '请输入图形验证码',
      phonepl: '请输入手机号',
      emailpl: '请输入邮箱',
      verificationCode: '请输入验证码',
      cancel: '取消',
      comfirm: '确认'
    },
    changeNickname: {
      txt1: '取消',
      txt2: '修改昵称',
      txt3: '完成',
      txt4: '请输入昵称',
      txt5: '修改成功'
    },
    loginPage: {
      txt1: '登录',
      txt2: '请输入手机号/邮箱',
      txt3: '请输入6-16位登录密码',
      txt4: '注册帐号',
      txt5: '忘记密码？',
      txt6: '短信登录',
      txt7: '微信登录',
      txt8: '注册',
      txt9: '请输入图形验证码',
      txt10: '请输验证码',
      txt11: '点击注册表示同意',
      txt12: '用户协议',
      txt13: '隐私政策',
      txt14: '儿童用户协议',
      txt15: '儿童隐私政策',
      txt16: '和',
      txt17: '获取验证码'
    }
  },
  common: {
    status: {
      txt1: '进行中',
      txt2: '已结束'
    },
    btns: {
      txt1: '确定',
      txt2: '取消',
      txt3: '返回'
    }
  },
  Activity: {
    txt1: '活动广场'
  },
  Discover: {
    discover: '发现'
  },
  NoAuthorityPage: {
    NoAuthority: '你没有访问权限哦~',
    predecessors: '完成前置任务后方可解锁当前任务'
  },
  ApplySchool: {
    applySchool: '申请新增学校',
    yourName: '你的名字：',
    ContactInformation: '联系方式：',
    yourSchool: '你的学校：',
    region: '行政区域：',
    remark: '备注：',
    description: '说明：组委会收到申请后，会有专人与你联系，协助完成报名。',
    submit: '提交',
    chooseArea: '选择行政区域',
    chooseProvincial: '省市选择',
    Cancel: '取消',
    OK: '确定',
    province: '省',
    city: '市',
    success: '提交成功！',
    SubmitFailure: '提交失败',
    copyLink: '提示',
    copy: '复制',
    copyTitle: '复制'
  },
  user: {
    phone: '请输入手机号/邮箱',
    psd: '请输入6-16位登录密码',
    rpsd: '请再次输入登录密码',
    imgValicode: '请输入图形验证码',
    validateCode: '手机/邮箱验证码',
    phoneOnly: '请输入手机号',
    emailOnly: '请输入邮箱',
    smsValidateCode: '请输入短信验证码',
    graphCode: '请输入图形验证码',
    verifCode: '手机/邮箱验证码',
    oldPassword: '请输入旧密码',
    newPassword: '请输入新密码',
    rePassword: '请再次输入新密码',
    rePassword1: '请再次输入密码',
    verificationCode: '请输入验证码',
    changePsd: '修改密码',
    changePnum: '更换手机',
    changeEmail: '更换邮箱',
    tip1: '请输入新的手机号并进行验证',
    tip2: '请输入新的邮箱并进行验证',
    tip3: '为了账号安全， 请先验证当前手机号：',
    tip4: '请输入新的手机号并进行验证',
    tip5: '为了账号安全， 请先验证当前邮箱：',
    tip6: '该账号不存在，请设置登录密码以完成注册流程',
    tip7: '和',
    oldPwd: '旧密码:',
    newPwd: '新密码:',
    rNewPwd: '确认新密码:',
    comfirm: '确认',
    cancel: '取消',
    phone1: '手机',
    email: '邮箱',
    password: '密码',
    Accounts: '账号设置',
    AccountBinding: '账号绑定',
    rightEmail: '请填写正确格式的邮箱',
    rightPhone: '请填写正确格式的手机号',
    ReplacementSuccessful: '更换成功',
    bindNow: '马上绑定',
    verifTip: '获取验证码',
    toReGet: 's后重新获取'
  }
}
const zh = {
  ...flowImageZH,
  ...messages,
  ...flowAcademicReportZH,
  ...flowActiveZH,
  ...flowAdmissionTicketZH,
  ...flowCertificateZH,
  ...flowComplainZH,
  ...flowConsultZH,
  ...flowCouponZH,
  ...flowDiscoverZH,
  ...flowFollowUsZH,
  ...flowGroupZH,
  ...flowGradeReportZH,
  ...flowLoginZH,
  ...flowMessageZH,
  ...flowHomeZH,
  ...flowOrderZH,
  ...flowPayTheFeesZH,
  ...flowPersonalDataZH,
  ...flowReviewZH,
  ...flowSignUpZH,
  ...flowTaskZH,
  ...flowTeamUpZH
}
export default zh



// WEBPACK FOOTER //
// ./src/assets/locale/zh.js